import { IColumn } from 'core-components/library/list/types'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'
import { IGlobalPartner } from 'partner360/widgets/gp360Administration/models/globalPartner'
import { TRANSLATION_KEYS } from 'partner360/widgets/gp360Administration/translations'

import { getValueTypeValue } from './getValueTypeValue'
import { GlobalPartnerFinancialColumnTitle } from './GlobalPartnerFinancialColumnTitle'

export const getColumns = (valueType: ActualsValueTypes): IColumn<IGlobalPartner>[] => [
  {
    field: '',
    title: '',
    priority: 1,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'GlobalPartnerName',
    title: TRANSLATION_KEYS.tableColumns.globalPartnerName,
    priority: 2,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'PBM',
    title: TRANSLATION_KEYS.tableColumns.globalPbm,
    priority: 3,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'PartnersCount',
    title: TRANSLATION_KEYS.tableColumns.globalPartnersCount,
    priority: 4,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'GlobalPartnerCompleteness',
    title: TRANSLATION_KEYS.tableColumns.globalFullyCompleted,
    priority: 5,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'PartnersCompletedCount',
    title: TRANSLATION_KEYS.tableColumns.globalFullyCompletedCount,
    priority: 6,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'PartnersFullyAcknowledgedCount',
    title: TRANSLATION_KEYS.tableColumns.globalFullyAcknowledgedCount,
    priority: 7,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'GlobalPartnerTargetsNdp',
    title: '',
    titleRender: () => (
      <GlobalPartnerFinancialColumnTitle
        translationKey={TRANSLATION_KEYS.tableColumns.globalPartnerActuals}
        valueType={valueType}
      />
    ),
    renderFunction: (item) => (
      <div>
        {getValueTypeValue({
          valueType,
          defaultValue: item.GlobalPartnerTargetsNdp,
          ndpValue: item.GlobalPartnerTargetsNdp,
          netValue: item.GlobalPartnerTargetsNet,
          tnetValue: item.GlobalPartnerTargetsTNet,
          utnetValue: item.GlobalPartnerTargetsUTNet,
        })}
      </div>
    ),
    priority: 8,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'PartnersTargetsNdp',
    title: '',
    titleRender: () => (
      <GlobalPartnerFinancialColumnTitle
        translationKey={TRANSLATION_KEYS.tableColumns.globalPartnerTargets}
        valueType={valueType}
      />
    ),
    renderFunction: (item) => (
      <div>
        {getValueTypeValue({
          valueType,
          defaultValue: item.PartnersTargetsNdp,
          ndpValue: item.PartnersTargetsNdp,
          netValue: item.PartnersTargetsNet,
          tnetValue: item.PartnersTargetsTNet,
          utnetValue: item.PartnersTargetsUTNet,
        })}
      </div>
    ),
    priority: 9,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'TargetsGap',
    title: TRANSLATION_KEYS.tableColumns.globalPartnerDiff,
    priority: 10,
    hideSettings: true,
    disableSort: true,
  },
  {
    field: 'TargetsGapPercentage',
    title: TRANSLATION_KEYS.tableColumns.globalPartnerDiffPercent,
    priority: 11,
    hideSettings: true,
    disableSort: true,
  },
]
